import { paths } from '~/routing/routes';
import { SignUpPage } from './SignUpPage';

// Keep existing links and Clerk continuation URLs without preselecting a role.
export const ProviderSignUpPage = () => <SignUpPage path={paths.publicAuth.signUpProvider} />;
